export enum ErrorMessages {
	ErrorContactAdministrator = 'An error has occurred! Please contact your administrator for further assistance.',
}
